var React = require('react');

function BackArrowIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.821 6.273c-.561 0-.844-.683-.442-1.086L8.43 2.131c.481-.482.481-1.287 0-1.769a1.26 1.26 0 0 0-1.766 0L.361 6.636c-.481.482-.481 1.287 0 1.769l6.222 6.234a1.24 1.24 0 0 0 .883.361c.321 0 .643-.121.883-.361.481-.482.481-1.287 0-1.769l-2.97-3.016c-.401-.402-.121-1.086.442-1.086h16.927c.723 0 1.325-.644 1.245-1.367-.082-.644-.684-1.128-1.325-1.128H5.821z","fill":"#606060","fillRule":"evenodd"}));
}

BackArrowIconInline.defaultProps = {"width":"24","height":"15","xmlnsV":"https://vecta.io/nano"};

module.exports = BackArrowIconInline;

BackArrowIconInline.default = BackArrowIconInline;
